import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DataEntryStore } from '../reducers/data-entry.reducer';

export const getDataEntryFeatureState = createFeatureSelector<DataEntryStore>('dataEntry');

export const getUploadReport = createSelector(getDataEntryFeatureState, (state: DataEntryStore) => {
  return state.fileImport.uploadReport;
});
